import { render } from "./text-field.vue?vue&type=template&id=82fb16e8"
import script from "./text-field.vue?vue&type=script&lang=js"
export * from "./text-field.vue?vue&type=script&lang=js"

import "./text-field.vue?vue&type=style&index=0&id=82fb16e8&lang=css"
script.render = render

export default script